import React, { useCallback } from 'react';
import { FormattedDate, FormattedMessage, FormattedTime } from 'react-intl';

import { useMessage } from '@tmapy/intl';

import { AttachmentIcon } from '../../docs/components/AttachmentIcon';
import { useAppContext, useHistoryAction } from '../../hooks';
import type { ServiceOrderListResponse } from '../../openapi/types/ServiceOrderList';
import { priceListMessages } from '../../priceList/components/priceListMessages';
import type { RouteId } from '../../routes';
import { getCmdCtrlUrl } from '../../utils/getcmdctrlurl';

import { formatItemQuantity, getItemName, getUserLabel } from '../utils';

import { ServiceOrderBadge } from './ServiceOrderBadge';

export const ServiceOrderListItem: React.FC<ServiceOrderListResponse> = (props) => {
  const { appType } = useAppContext();
  const formatMessage = useMessage();
  const routeToDetail = useHistoryAction('vydejServiceOrderDetail', { id: props.id });

  const handleClick = useCallback(
    (event: React.MouseEvent) => {
      if (event.ctrlKey || event.metaKey) {
        window.open(
          getCmdCtrlUrl('vydejServiceOrderDetail' as RouteId, { appType, id: props.id }),
          '_blank',
        );
        return; // Ponech nativní chování
      }

      const selectText = window.getSelection();
      if (!selectText || selectText.toString() === '') {
        routeToDetail();
      }
    },
    [routeToDetail, appType, props.id],
  );

  return (
    <tr onClick={handleClick}>
      <td className='sg-a-ta-c'>
        <div className='sg-u-type-bold sg-a-fvn-tn'>{props.document_number}</div>
        <div className='sg-a-mt-1/2'>
          <ServiceOrderBadge state={props.state} />
        </div>
      </td>
      <td className='sg-u-type-bold'>{props.name}</td>
      <td>
        {props.items.map((item) => (
          <div key={item.id}>{getItemName(item)}</div>
        ))}
      </td>
      <td className='sg-a-ta-r sg-a-ws-nw sg-a-fvn-tn'>
        {props.items.map((item) => (
          <div key={item.id}>
            {formatItemQuantity(formatMessage, item)}
          </div>
        ))}
      </td>
      <td className='sg-a-ta-r sg-a-ws-nw sg-a-fvn-tn'>
        {props.total_gross && (
          <FormattedMessage {...priceListMessages.priceCzk} values={{ price: props.total_gross }} />
        )}
      </td>
      <td>{getUserLabel(props.odberatel)}</td>
      <td className='sg-a-ta-r sg-a-ws-nw sg-a-fvn-tn'>
        <div>
          <FormattedDate value={new Date(props.created)} />{' '}
          <FormattedTime value={new Date(props.created)} />
        </div>
        {props.paid && (
          <div className='sg-u-c-cta-black'>
            <FormattedDate value={new Date(props.paid)} />{' '}
            <FormattedTime value={new Date(props.paid)} />
          </div>
        )}
      </td>
      <td className='sg-a-w-0'>
        {props.attachments.length > 0 && <AttachmentIcon count={props.attachments.length} />}
      </td>
    </tr>
  );
};
